import React from 'react';
import Modal, { ModalHeader } from '@xo-union/tk-component-modals';
import styles from './guest-count-modal.scss';
import { Button } from '@xo-union/tk-component-buttons';
import { DisplayButton } from '@xo-union/tk-ui-links';
import { Select, Option } from '@xo-union/tk-component-fields';

interface Props {
  guestCount: string;
  open: boolean;
  setClose: () => void;
  onSuccess: (guestRange: string) => void;
}

const GuestCountModal: React.FC<Props> = ({ guestCount, open, setClose, onSuccess }) => {
  const [value, setValue] = React.useState<string>(guestCount);

  return open ? (
    <Modal size="md" onClose={setClose} className={styles.modal}>
      <ModalHeader className={styles.modalHeader}>Edit your guest count</ModalHeader>
      <div className={styles.modalBody}>
        <Select
          label="Estimated guest count"
          name="guestCount"
          value={value}
          onChange={(event: React.ChangeEvent<HTMLSelectElement>) => setValue(event.target.value)}
        >
          <Option value="0&ndash;50" />
          <Option value="51&ndash;100" />
          <Option value="101&ndash;150" />
          <Option value="151&ndash;200" />
          <Option value="201&ndash;300" />
          <Option value="300+" />
        </Select>
      </div>
      <div className={styles.modalFooter}>
        <DisplayButton className={styles.closeBtn} onClick={() => setClose()}>
          Cancel
        </DisplayButton>
        <Button className={styles.saveBtn} color="primary" size="lg" onClick={() => onSuccess(value)}>
          Save
        </Button>
      </div>
    </Modal>
  ) : null;
};

export default GuestCountModal;
